import React, { useEffect, useState } from "react";
import "./DocumentCenter.css";
import { Modal, Button } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { httpGetConsignementContract } from "../../../../service/httpClient";
import * as Constants from "../../../../constants/Constants";
import { getBlmDept, getMacyDept, verifyIfCheckedUnchecked } from "../../OnboardingHelper";

const ManageContract = (props) => {
  const [initData, setInitData] = useState("");
  const [htmlBody, setHtmlBody] = useState("");
  const [previewMode, setPreviewMode] = useState(true);
  const {
    vendorDetail,
    mailAddress,
    primaryContact,
    mbeWbeVendorDetails,
  } = props.vendorProfile || {};
  
  const contractType =
    typeof props.contractType === "undefined" || !props.contractType
      ? Constants.CONSIGNMENT_TYPE
      : props.contractType;
 
  const {
    id,
    vendorCorpName,
    companyType,
    hierarchyDetails = [],
    duns,
  } = vendorDetail || {};
  const vendorProfileId = id || null;
  const { streetAddress, city, state, zipCode, email } = mailAddress || {};
  const { firstName, lastName, role, phoneNumber } = primaryContact || {};

  const {
    fax,
    federalId,
    website,
    ceoEmail,
    avgEmployees,
    avgCompletedSales,
    mbeStatus,
    mbeGroups,
    wbeStatus,
    organization,
  } = mbeWbeVendorDetails || {};

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlBody, "text/html");

  const contractPlaceHolderObj = {
    "{todaysDate}":
      new Date().toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      }) || "____________",
    "{vendorCorpName}": vendorCorpName || "____________",
    "{companyType}": companyType || "____________",
    "{mailingStreetAddress}": streetAddress || "____________",
    "{city}": city || "____________",
    "{state}": state || "____________",
    "{zipCode}": zipCode || "____________",
    "{vendorPrimaryEmail}": email || "____________",
    "{vendorPrimaryContactName}":
      (firstName || "____________") + " " + (lastName || "____________"),
    "{vendorPrimaryRole}": role || "____________",
    "{mcyDivision} | {mcyDept} | {mcyVendorNbr}": "",
    "{blmDivision} | {blmDept} | {blmVendorNbr}": "",
    "{primaryStreetAddress}": "{primaryStreetAddress}",

    "{primaryPhone}": phoneNumber || "____________",
    "{fax}": fax || "____________",
    "{federalId}": federalId || "____________",
    "{duns}": duns || "____________",
    "{ceoEmail}": ceoEmail || "____________",
    "{website}": website || "____________",
    "{avgEmployeeCount}": avgEmployees || "____________",
    "{avgCompletedSales}": avgCompletedSales || "____________",
    'type="checkbox"': 'type="checkbox" disabled="disabled"',

    "{isMbeChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_MBE_STATUS.MINORITY_OWNED,
      mbeStatus
    ),
    "{isNonMbeChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_MBE_STATUS.NOT_MINORITY_OWNED,
      mbeStatus
    ),

    "{isAsianPacificChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_MBE_GROUPS.ASIAN_PACIFIC_AMERICAN,
      mbeGroups
    ),
    "{isAsianIndChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_MBE_GROUPS.ASIAN_INDIAN_AMERICAN,
      mbeGroups
    ),
    "{isBlckChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_MBE_GROUPS.BLACK_AFRICAN_AMERICAN,
      mbeGroups
    ),
    "{isHispanicChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_MBE_GROUPS.HISPANIC_AMERICAN,
      mbeGroups
    ),
    "{isNativeChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_MBE_GROUPS.NATIVE_AMERICAN,
      mbeGroups
    ),
    "{isLGBTQChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_MBE_GROUPS.LGBTQ,
      mbeGroups
    ),
    "{isDisablityChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_MBE_GROUPS.PERSON_DISABILITY,
      mbeGroups
    ),
    "{isVeteranChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_MBE_GROUPS.VETERAN,
      mbeGroups
    ),

    "{isWbeChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_WBE_STATUS.WOMEN_OWNED,
      wbeStatus
    ),
    "{isNonWbeChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_WBE_STATUS.NOT_WOMEN_OWNED,
      wbeStatus
    ),

    "{isMcyChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_BUSINESS_ORGS.MACYS,
      organization
    ),
    "{isBlmChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_BUSINESS_ORGS.BLOOMS,
      organization
    ),
    "{isBlueMercuryChecked}": verifyIfCheckedUnchecked(
      Constants.FLAGS_BUSINESS_ORGS.BLUEM,
      organization
    ),
  };

  const mcyDivision = getMacyDept(hierarchyDetails) !== "" ? "Macy's" : null;
  const blmDivision =
    getBlmDept(hierarchyDetails) !== "" ? "Bloomingdale's" : null;

  if (mcyDivision) {
    contractPlaceHolderObj["{mcyDivision} | {mcyDept} | {mcyVendorNbr}"] =
      mcyDivision + " | " + getMacyDept(hierarchyDetails) + " | " + 0;
  }

  if (blmDivision) {
    contractPlaceHolderObj["{blmDivision} | {blmDept} | {blmVendorNbr}"] =
      blmDivision + " | " + getBlmDept(hierarchyDetails) + " | " + 0;
  }

  if (mcyDivision === null && blmDivision) {
    contractPlaceHolderObj["{mcyDivision} | {mcyDept} | {mcyVendorNbr}"] =
      blmDivision + " | " + getBlmDept(hierarchyDetails) + " | " + 0;
    contractPlaceHolderObj["{blmDivision} | {blmDept} | {blmVendorNbr}"] = "";
  }

  useEffect(() => {
    if (props.showModal) {
      httpGetConsignementContract(vendorProfileId, contractType)
        .then((response) => {
          setInitData(response?.data);
          setHtmlBody(response?.data);
        })
        .catch((error) => {
          this.setState({
            errorMessage: error.response?.data?.message,
            isError: true,
          });
        });
    }
  }, [props.showModal, vendorProfileId]);

  const previewHtmlData = (htmlContract) => {
    Object.entries(contractPlaceHolderObj).forEach(([key, value]) => {
      htmlContract = htmlContract.replaceAll(key, value);
    });
    doc.querySelector("body").innerHTML = htmlContract;
    return doc.documentElement.outerHTML;
  };

  const handleCloseModal = () => {
    props.handleCloseViewModifyModal();
  };

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setInitData(data);
  };

  const handleSave = () => {
    let fileContent = '';
    if(!contractType || contractType === Constants.CONSIGNMENT_TYPE) {
      doc.querySelector("body").innerHTML = initData;
      fileContent = doc.documentElement.outerHTML;
    } else {
      fileContent = initData;
    }
    props.handleGenerateContract(fileContent, contractType);
    handleCloseModal();
  };

  const checkIsEditableContract = () => {
    return (!contractType || contractType === Constants.CONSIGNMENT_TYPE) ? true : false;
  }

  return (
    <div>
      <Modal
        dialogClassName="vc-modal-container"
        show={props.showModal}
        onHide={() => {
          handleCloseModal();
          setPreviewMode(true);
        }}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <div className="modalHeader">
            <h3>
              {previewMode
                ? Constants.PREVIEW_CONTRACT
                : Constants.EDIT_CONTRACT}
            </h3>
            <span>
              (<strong>{Constants.NOTE}</strong>
              {Constants.EDIT_CONTRACT_NOTE})
            </span>
          </div>
        </Modal.Header>
        <Modal.Body className="model-preview-body">
          {checkIsEditableContract() && (
            <div style={{ display: `${previewMode ? "none" : "block"}` }}>
              <CKEditor
                editor={DecoupledEditor}
                data={initData}
                onReady={(editor) => {
                  editor.ui
                    .getEditableElement()
                    .parentElement.insertBefore(
                      editor.ui.view.toolbar.element,
                      editor.ui.getEditableElement()
                    );
                  return editor;
                }}
                onChange={handleEditorChange}
              />
            </div>
          )}
          {previewMode && (
            <div
              className="preview-contract"
              dangerouslySetInnerHTML={{
                __html: previewMode && previewHtmlData(initData),
              }}
            ></div>
          )}
        </Modal.Body>
        <Modal.Footer className="model-contract-footer">
          {checkIsEditableContract() && (
            <Button
              variant="primary"
              className="button-secondary-md"
              style={{ marginRight: 20 }}
              onClick={() => setPreviewMode(!previewMode)}
            >
              {!previewMode ? Constants.PREVIEW : Constants.EDIT}
            </Button>
          )}
          <Button
            variant="primary"
            className="button-primary-md"
            onClick={() => handleSave()}
          >
            {Constants.GENERATE_CONTRACT}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ManageContract;
